export default __webpack_public_path__ + "static/media/dropdown-arrow.d5165a19.svg";